import { Component, OnInit } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'

@Component({
	selector: 'app-breadcrumb',
	templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent implements OnInit {
	public companyName: string
	public actualPage: string

	constructor(private router: Router) {}

	public ngOnInit(): void {
		this.companyName = localStorage.getItem('companyName')

		switch (this.router.url) {
			case '/panel/companyAdmin':
				this.actualPage = 'Adm usuários'
				break
			case '/panel/scheduling':
				this.actualPage = 'Avaliação / Agendamento'
				break
			case '/panel/evaluator':
			case '/panel/demandsHistory':
			case '/panel/scheduler':
				this.actualPage = 'Avaliação'
				break
			case '/panel/operator':
			case '/panel/operationService':
			case '/panel/operationHistory':
				this.actualPage = 'Manejo'
				break
			default:
		}
	}

	public backGeneralUser(): void {
		localStorage.removeItem('loggedCompany')
		localStorage.removeItem('companyId')
		localStorage.removeItem('companyName')
		localStorage.setItem('comingFromCompany', 'true')
		this.router.navigate(['/redirect'])
	}
}
